import { UPDATE_RESPONSIVE_QUERIES } from '../actions/responsive';
import { defaultQueries } from '../thunks/responsive';
import get from 'lodash/get';
import mapValues from 'lodash/mapValues';

const defaultState = (model) => { 
  const mediaQueries = mapValues(defaultQueries, () => false);
  const uaType = get(model, 'userAgent.device.type');

  switch (uaType) { 
    case 'mobile':
      mediaQueries.mobile = true;
      mediaQueries.fabletDown = true;  
      mediaQueries.tabletDown = true;
      mediaQueries.desktopDown = true;    
      break;
    case 'tablet':
      mediaQueries.fabletUp = true;
      mediaQueries.tablet = true;
      mediaQueries.tabletUp = true;
      mediaQueries.desktopDown = true;
      break;
    default:
      mediaQueries.fabletUp = true;
      mediaQueries.tabletUp = true;
      mediaQueries.desktop = true; 
      mediaQueries.desktopUp = true;   
      break;
  }

  return mediaQueries;
};

/**
 * 
 * @param {object} model - This is an optional argument, because the default state handles it above (line 7) 
 */
export const responsive = (model) => (state, action) => {
  if (!state) {
    state = defaultState(model);
  }
  switch (action.type) {
    case UPDATE_RESPONSIVE_QUERIES:
      return {
        ...state,
        ...action.queries
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/client/js/store/reducers/responsive.js